import React from "react";
import PropTypes from "prop-types";
import Button from "../general/Button/Button";
import "./ConfirmExitModal.css";

const ConfirmExitModal = ({ isOpen, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="confirmation-overlay">
            <div className="confirmation-popup">
                <h3 className="confirmation-title">Tem certeza que deseja sair?</h3>
                <p className="confirmation-subtitle">
                    Existem alterações não salvas nesta página.
                    Se sair agora, todas as mudanças serão perdidas.
                </p>

                <div className="confirmation-buttons">
                    <Button
                        type="button"
                        variant="cancel"
                        className="btn-cancel"
                        onClick={onCancel}
                    >
                        Continuar editando
                    </Button>

                    <Button
                        type="button"
                        variant="delete"
                        className="btn-delete"
                        onClick={onConfirm}
                    >
                        Descartar alterações
                    </Button>
                </div>
            </div>
        </div>
    );
};

ConfirmExitModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ConfirmExitModal;
